module.exports = new __parcel__URL__("cornershop-new-web.7631c914.png").toString();